import {makeBFFApiUrl} from 'main/factories/http';

import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';

import {RemoteRefundPutUpdateRequest} from 'data/usecases/private/refund/request/remote-put-update-request';
import {PutRefundUpdateRequest} from 'domain/usecases/private/refund/request/put-update-request';
import {RefundFlowEndPoints} from '../../../endpoints';

export const makePutRefundUpdateRequest = (): PutRefundUpdateRequest =>
	new RemoteRefundPutUpdateRequest(
		makeBFFApiUrl(RefundFlowEndPoints.protocol),
		makeAuthorizeHttpClientDecorator(),
	);
